module.exports = __webpack_public_path__ + "img/baudelaire.59fb149e.jpg";